var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('nav-bar',{staticClass:"app-content-header"}),_c('div',{staticClass:"app-content"},[_c('side-bar',{staticClass:"app-sidebar"}),_c('app-main',{staticClass:"app-content-content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }